import { render, staticRenderFns } from "./QueryInfo.vue?vue&type=template&id=146b0533&scoped=true"
import script from "./QueryInfo.vue?vue&type=script&lang=js"
export * from "./QueryInfo.vue?vue&type=script&lang=js"
import style0 from "./QueryInfo.vue?vue&type=style&index=0&id=146b0533&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146b0533",
  null
  
)

export default component.exports